import { ForecastWellRiskBase } from './base/forecast-well-risk-base';

export class ForecastWellRisk extends ForecastWellRiskBase { }